export const ModuleName = Object.freeze({
  CAMPAIGN: 'campaign'
})
